<template>
  <div class="container step">
    <div class="head-top">
      <img v-if="selectFlow.flow1 === false" src="../../assets/step2/page2_head.png" alt="">
      <img v-if="selectFlow.flow1" src="../../assets/step2/page2_head_change.png" alt="">
      <div class="text">
          針對第一線不適合Cisplatin療法的轉移性上泌
          尿道上皮癌病患,在接受TECENTRIQ治療後，整體存活期中位數
        <span class="caption">mOS</span> 達 <span class="caption">33</span>個月
        <h5 style="color:#f5ad33;margin:0;">
        (IMvigor 210 Phase II, n=119)
        </h5>
      </div>
    </div><!-- Top end sub-->
    <div class="flow-container">
      <a href="#" @click.prevent="selectFlow.flow1 = !selectFlow.flow1" style="width:90%;">
        <div class="flow-text">
            IMvigor 210 Phase II, multicenter, open-label, 2-cohort trial design in locally advanced or metastatic urothelial carcinoma (n=429)
        </div>
        <img v-if="selectFlow.flow1 === false" src="../../assets/step2/page2_flow.png" alt="">
        <img v-if="selectFlow.flow1" src="../../assets/step2/page2_flow_change.png" alt="">
      </a>
    </div>
    <template>
      <router-link to="/step2-1" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step3" class="btn-next el-icon-arrow-right"></router-link>
    </template>
    <div class="footerText">
        2018 American Society of Clinical Oncology (Asco) June 1-5,2018, Chicago, IL, USA Abstract#4523
    </div>
  </div>
</template>

<script>
export default {
  name: 'step1-2',
  props: ['result'],
  mounted: function () {
    console.log(this.result)
  },
  data () {
    return {
      pageChage: false,
      selectFlow: {
        flow1: false,
        flow2: false
      }
    }
  }
}
</script>

<style scoped>
  .step .head-top .text .caption {color:#f39800;}
  a[class*="btn-"] {
    background:#f39800;color:white;
  }
  a {text-decoration:none;}
  .flow-text {
    color:#5f5f5f;font-size:14px;
    text-align:left;display:block;
  }
</style>



// WEBPACK FOOTER //
// src/components/step2/flow.vue